var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8398 6.23841C15.8398 6.74268 15.7405 7.24201 15.5475 7.7079C15.3546 8.17379 15.0717 8.5971 14.7151 8.95368C14.3586 9.31025 13.9353 9.5931 13.4694 9.78608C13.0035 9.97905 12.5041 10.0784 11.9999 10.0784C11.4956 10.0784 10.9963 9.97905 10.5304 9.78608C10.0645 9.5931 9.64118 9.31025 9.2846 8.95368C8.92803 8.5971 8.64518 8.17379 8.4522 7.7079C8.25923 7.24201 8.1599 6.74268 8.1599 6.23841C8.1599 5.21998 8.56447 4.24327 9.2846 3.52314C10.0047 2.803 10.9815 2.39844 11.9999 2.39844C13.0183 2.39844 13.995 2.803 14.7151 3.52314C15.4353 4.24327 15.8398 5.21998 15.8398 6.23841Z",
    fill: "url(#paint0_linear_1584_67699)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43088 20.319L6.493 11.6255C6.63871 11.2719 6.99228 11.0383 7.38442 11.0383H16.6158C17.0079 11.0383 17.3615 11.2698 17.5072 11.6255L20.5693 20.319C20.8222 20.9318 20.3572 21.5982 19.6779 21.5982H4.32016C3.64302 21.5982 3.17803 20.9318 3.43088 20.319Z",
    fill: "url(#paint1_linear_1584_67699)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8652 20.6598C11.2138 20.587 10.7466 19.9977 10.8195 19.3462L11.4838 13.4984H11.2824C10.8966 13.4984 10.6695 13.0656 10.8881 12.7484L11.6081 11.7049C11.7966 11.4285 12.2038 11.4285 12.3945 11.7049L13.1145 12.7484C13.3331 13.0656 13.1059 13.4984 12.7202 13.4984H12.5188L13.1788 19.3484C13.1873 19.432 13.1895 19.5262 13.1788 19.6141C13.1038 20.2655 12.5166 20.7327 11.8652 20.6598Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_67699",
    x1: 11.9999,
    y1: 2.39844,
    x2: 11.9999,
    y2: 10.0784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E91E67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1584_67699",
    x1: 12.0001,
    y1: 11.0383,
    x2: 12.0001,
    y2: 21.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E91E67"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.d3627df7760db9ba83d2ee3ec11be54a.svg";
export { ForwardRef as ReactComponent };